module.exports = __webpack_public_path__ + "img/6h.76814d85.png";